module.exports = __webpack_public_path__ + "static/Chennai-9827c2c9a8fb854fa6a4fee706c35727.png";